import { Link, type LinkProps } from 'react-router-dom'
import type { ButtonSize, ButtonVariant } from './Button'
import buttonStyles from './Button.module.css'

export type ButtonLinkProps = LinkProps & {
  variant?: ButtonVariant
  size?: ButtonSize
}

const variantClass: Record<ButtonVariant, string> = {
  primary: buttonStyles.variantPrimary,
  secondary: buttonStyles.variantSecondary,
  ghost: buttonStyles.variantGhost,
  danger: buttonStyles.variantDanger,
}

const sizeClass: Record<ButtonSize, string> = {
  sm: buttonStyles.sizeSm,
  md: buttonStyles.sizeMd,
  lg: buttonStyles.sizeLg,
}

export function ButtonLink({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...rest
}: ButtonLinkProps) {
  const composed = [buttonStyles.button, variantClass[variant], sizeClass[size], className]
    .filter(Boolean)
    .join(' ')

  return (
    <Link className={composed} {...rest}>
      {children}
    </Link>
  )
}
